export default __webpack_public_path__ + "static/gallery-img3-41c3df67b77fa2d9ebab7c0b5730849f.jpg";